exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tos {\n  width: auto;\n  padding: 10px;\n  margin: 0;\n  font-size: 0.9em;\n}\n.tos p {\n  margin-bottom: 10px;\n  text-indent: 10px;\n}\n.tos hr {\n  width: 70%;\n  margin: 10px 15%;\n  border: 0 solid transparent;\n  border-top: 1px solid #333;\n}\n.tos .text {\n  width: 100%;\n}\n.tos .text * {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n.tos .text p {\n  margin-top: 6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/pages/TermsOfService.less
// module id = 1369
// module chunks = 0